import { Slot } from "@radix-ui/react-slot";
import { cn } from "@scott/ui/client";
import type { ImgHTMLAttributes } from "react";

interface youtubeProps extends ImgHTMLAttributes<HTMLImageElement> {
  asChild?: boolean;
}

const Youtube = ({ className, asChild = false }: youtubeProps) => {
  const Comp = asChild ? Slot : "svg";
  return (
    <Comp
      className={cn("fill-[--brand-followus-logo]", className)}
      fill="none"
      height="32"
      viewBox="0 0 28 28"
      width="28"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M17.625 14.0625L11.625 17.4375V10.6875L17.625 14.0625ZM24 0C26.1875 0 28 1.8125 28 4V24C28 26.25 26.1875 28 24 28H4C1.75 28 0 26.25 0 24V4C0 1.8125 1.75 0 4 0H24ZM24.875 8.5625C24.625 7.5625 23.8125 6.75 22.875 6.5C21.0625 6 14 6 14 6C14 6 6.875 6 5.0625 6.5C4.125 6.75 3.3125 7.5625 3.0625 8.5625C2.625 10.3125 2.625 14.0625 2.625 14.0625C2.625 14.0625 2.625 17.75 3.0625 19.5625C3.3125 20.5625 4.125 21.3125 5.0625 21.5625C6.875 22 14 22 14 22C14 22 21.0625 22 22.875 21.5625C23.8125 21.3125 24.625 20.5625 24.875 19.5625C25.375 17.75 25.375 14.0625 25.375 14.0625C25.375 14.0625 25.375 10.3125 24.875 8.5625Z" />
    </Comp>
  );
};

Youtube.displayName = "Youtube";

export { Youtube };
